/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createWorkPackageFieldsSchema } from '../fn/work-package-fields-schema/create-work-package-fields-schema';
import { CreateWorkPackageFieldsSchema$Params } from '../fn/work-package-fields-schema/create-work-package-fields-schema';
import { getWorkPackageFieldsSchema } from '../fn/work-package-fields-schema/get-work-package-fields-schema';
import { GetWorkPackageFieldsSchema$Params } from '../fn/work-package-fields-schema/get-work-package-fields-schema';
import { listWorkPackageFieldsSchema } from '../fn/work-package-fields-schema/list-work-package-fields-schema';
import { ListWorkPackageFieldsSchema$Params } from '../fn/work-package-fields-schema/list-work-package-fields-schema';
import { updateCurrentWorkPackageFieldsSchema } from '../fn/work-package-fields-schema/update-current-work-package-fields-schema';
import { UpdateCurrentWorkPackageFieldsSchema$Params } from '../fn/work-package-fields-schema/update-current-work-package-fields-schema';
import { WorkPackageFieldsSchemaDto } from '../models/work-package-fields-schema-dto';
import { WorkPackageFieldsSchemaDtoPage } from '../models/work-package-fields-schema-dto-page';

@Injectable({ providedIn: 'root' })
export class WorkPackageFieldsSchemaApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listWorkPackageFieldsSchema()` */
  static readonly ListWorkPackageFieldsSchemaPath = '/v0/WorkPackageFieldsSchema';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listWorkPackageFieldsSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  listWorkPackageFieldsSchema$Response(params?: ListWorkPackageFieldsSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageFieldsSchemaDtoPage>> {
    return listWorkPackageFieldsSchema(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listWorkPackageFieldsSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listWorkPackageFieldsSchema(params?: ListWorkPackageFieldsSchema$Params, context?: HttpContext): Observable<WorkPackageFieldsSchemaDtoPage> {
    return this.listWorkPackageFieldsSchema$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPackageFieldsSchemaDtoPage>): WorkPackageFieldsSchemaDtoPage => r.body)
    );
  }

  /** Path part for operation `getWorkPackageFieldsSchema()` */
  static readonly GetWorkPackageFieldsSchemaPath = '/v0/WorkPackageFieldsSchema/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWorkPackageFieldsSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkPackageFieldsSchema$Response(params: GetWorkPackageFieldsSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageFieldsSchemaDto>> {
    return getWorkPackageFieldsSchema(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWorkPackageFieldsSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkPackageFieldsSchema(params: GetWorkPackageFieldsSchema$Params, context?: HttpContext): Observable<WorkPackageFieldsSchemaDto> {
    return this.getWorkPackageFieldsSchema$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPackageFieldsSchemaDto>): WorkPackageFieldsSchemaDto => r.body)
    );
  }

  /** Path part for operation `createWorkPackageFieldsSchema()` */
  static readonly CreateWorkPackageFieldsSchemaPath = '/v0/WorkPackageFieldsSchema/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createWorkPackageFieldsSchema()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createWorkPackageFieldsSchema$Response(params: CreateWorkPackageFieldsSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageFieldsSchemaDto>> {
    return createWorkPackageFieldsSchema(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createWorkPackageFieldsSchema$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createWorkPackageFieldsSchema(params: CreateWorkPackageFieldsSchema$Params, context?: HttpContext): Observable<WorkPackageFieldsSchemaDto> {
    return this.createWorkPackageFieldsSchema$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPackageFieldsSchemaDto>): WorkPackageFieldsSchemaDto => r.body)
    );
  }

  /** Path part for operation `updateCurrentWorkPackageFieldsSchema()` */
  static readonly UpdateCurrentWorkPackageFieldsSchemaPath = '/v0/WorkPackageFieldsSchema/{id}/current';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCurrentWorkPackageFieldsSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateCurrentWorkPackageFieldsSchema$Response(params: UpdateCurrentWorkPackageFieldsSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageFieldsSchemaDto>> {
    return updateCurrentWorkPackageFieldsSchema(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCurrentWorkPackageFieldsSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateCurrentWorkPackageFieldsSchema(params: UpdateCurrentWorkPackageFieldsSchema$Params, context?: HttpContext): Observable<WorkPackageFieldsSchemaDto> {
    return this.updateCurrentWorkPackageFieldsSchema$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPackageFieldsSchemaDto>): WorkPackageFieldsSchemaDto => r.body)
    );
  }

}
